import { render, staticRenderFns } from "./M4_S13.vue?vue&type=template&id=ae40dd38&scoped=true"
import script from "./M4_S13.vue?vue&type=script&lang=js"
export * from "./M4_S13.vue?vue&type=script&lang=js"
import style0 from "./M4_S13.vue?vue&type=style&index=0&id=ae40dd38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae40dd38",
  null
  
)

export default component.exports